import { SystemConfigStructureItemType } from './systemConfigDetail';

export interface ProviderConfigItemType {
    ID?: number;
    ITEM_KEY: string;
    VALUE: string | null;
    ID_PROVIDER?: string;
}

export interface ProviderConfigDetailFetchPayloadType {
    idProvider: string;
    system?: string;
}

export interface ProviderConfigStructureFetchPayloadType {
    idProvider: string;
    system?: string;
}

export interface ProviderConfigDetailUpdatePayloadType {
    idProvider: string;
    data: ProviderConfigItemType[];
    system?: string;
}

export interface ProviderConfigDetailStateType {
    loading: boolean;
    structureLoading: boolean;
    data: ProviderConfigItemType[] | null;
    structureData: SystemConfigStructureItemType[] | null;
    dataKey: string | null;
    structureKey: string | null;
    error: boolean;
}

export interface ProviderConfigDetailDataResType {
    data: ProviderConfigItemType[];
}

export interface ProviderConfigStructureResType {
    data: SystemConfigStructureItemType[];
}

export interface ProviderConfigDetailFetchSuccessPayloadType extends ProviderConfigDetailDataResType {
    request: ProviderConfigDetailFetchPayloadType;
}

export interface ProviderConfigStructureFetchSuccessPayloadType extends ProviderConfigStructureResType {
    request: ProviderConfigStructureFetchPayloadType;
}

export interface ProviderConfigDetailUpdateSuccessPayloadType extends ProviderConfigDetailDataResType {
    request: ProviderConfigDetailUpdatePayloadType;
    messageSuccess?: { title: string };
}

export interface ProviderConfigStructureCreatePayloadType {
    idProvider: string;
    system?: string;
    structureItem: SystemConfigStructureItemType;
}

export interface ProviderConfigStructureUpdatePayloadType {
    idProvider: string;
    system?: string;
    id: string;
    data: SystemConfigStructureItemType;
}

export const getProviderConfigRequestKey = (
    idProvider: string,
    system?: string
): string => `${idProvider}|${system ?? ''}`;
